module.exports = window["popupMaker"]["i18n"];